<template>
    <v-container height="80%" fluid>
        <v-row>
          <v-col cols="12" align="center" style="margin-top:3%;">
            <v-btn :to="$t('Alias.AdministracionGeneral')" text class="ma-3">{{ $t('Menu.AdministracionGeneral') }}</v-btn>
            <v-btn :to="$t('Alias.AdministracionPedidos')" text class="ma-3">{{ $t('Menu.AdministracionPedidos') }}</v-btn>
            <v-btn :to="$t('Alias.AdministracionPagos')" text class="ma-3">{{ $t('Menu.AdministracionEntregaDinero') }}</v-btn>
            <v-btn :to="$t('Alias.AdministracionUsuarios')" text class="ma-3">{{ $t('Menu.AdministracionUsuarios') }}</v-btn>
            <v-btn :to="$t('Alias.AdministracionAplicaciones')" text class="ma-3">{{ $t('Menu.AdministracionAplicaciones') }}</v-btn>
            <v-btn :to="$t('Alias.AdministracionProductos')" text class="ma-3">{{ $t('Menu.AdministracionProductos') }}</v-btn>
            <v-btn :to="$t('Alias.AdministracionCupones')" text class="ma-3">{{ $t('Menu.AdministracionCupones') }}</v-btn>
            <v-btn :to="$t('Alias.AdministracionMagazine')" text class="ma-3">{{ $t('Menu.AdministracionMagazine') }}</v-btn>
            <v-btn :to="$t('Alias.AdministracionExperiencias')" text class="ma-3">{{ $t('Menu.AdministracionExperiencias') }}</v-btn>
            <v-btn :to="$t('Alias.AdministracionPaginas')" text class="ma-3">{{ $t('Menu.AdministracionPaginas') }}</v-btn>
            <v-btn :to="$t('Alias.AdministracionManual')" text class="ma-3">{{ $t('Menu.AdministracionManual') }}</v-btn>
            <v-btn :to="$t('Alias.AdministracionContratos')" text class="ma-3">{{ $t('Menu.AdministracionContratos') }}</v-btn>
             <v-btn :to="$t('Alias.AdministracionCertificados')" text class="ma-3">{{ $t('Menu.AdministracionCertificados') }}</v-btn>
            <v-btn :to="$t('Alias.AdministracionNewsletter')" text class="ma-3">{{ $t('Menu.AdministracionNewsletter') }}</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <router-view />
        </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'Administracion'
}
</script>
